import React from "react";
import { useParams } from "react-router-dom";
import { EvtHeader } from "components/header";
import EditItemButton from "components/buttons/edit";
import { EvtStatsCard } from "components/stats/display-card";
import TiptapEditor from "components/tiptap-editor";
import { DropdownMenuItem } from "ui/components/dropdown-menu";
import { PermissionControlledInput } from "permissions/components/input";
import AvatarDisplay from "components/avatar/display";
import HeaderPortal from "components/portal/header-portal";
import { formatName } from "utils";
import { useFetch } from "@/hooks/useFetch";
import { fetchOpeningApplicantMeta } from "./api";
import ApplicantInterviews from "./interviews";


export default function OpeningApplicantDetails() {
    const { applicantId } = useParams();

    const { data: applicant, isLoading, isError } = useFetch({
        queryKey: [applicantId],
        queryFn: () => fetchOpeningApplicantMeta({ applicantId }),
    });

    if (isLoading) return <div className="p-8">Loading...</div>;

    if (isError) return (
        <div className="p-8 text-red-500">Error loading applicant details.</div>
    );

    if (!applicant) return <div className="p-8">No applicant found.</div>;

    const selected = applicant?.is_selected

    return (
        <div className="flex-1">
            <EvtHeader title="Details" />
            <section>
                <div className="grid grid-cols-3 px-4 gap-4 md:px-6 min-h-24">
                    {/* Employee */}
                    <EvtStatsCard
                        label="Employee"
                        value={<div className="flex items-center gap-2 mt-1">
                            <AvatarDisplay className="w-8 h-8" user={applicant?.employee} />
                            <p className="text-base">{formatName(applicant?.employee)}</p>
                        </div>}
                    />
                    {/* Experience */}
                    <EvtStatsCard
                        label="Experience (years)"
                        value={<p className="text-base">{applicant?.experience}</p>}
                    />
                    {/* Selected */}
                    <EvtStatsCard
                        label="Selected"
                        value={<p className="text-base">{selected ? "Yes" : "No"}</p>}
                    />
                </div>
                <div className="px-6 mt-2">
                    {applicant?.resume_url && <div>
                        <div className="font-medium mb-1">Resume URL</div>
                        <div className="font-normal text-sm leading-relaxed text-gray-700 bg-gray-50/50 p-4 rounded-lg border border-gray-200/60 whitespace-pre-wrap">
                            <a href={applicant?.resume_url} target="_blank" rel="noopener noreferrer">{applicant?.resume_url}</a>
                        </div>
                    </div>}
                    {applicant?.description && <div>
                        <div className="font-medium mb-1">Description</div>
                        <div className="font-normal text-sm leading-relaxed text-gray-700 bg-gray-50/50 p-4 rounded-lg border border-gray-200/60 whitespace-pre-wrap">
                            <TiptapEditor value={applicant?.description} readOnly={true} />
                        </div>
                    </div>}
                </div>
            </section>

            <ApplicantInterviews applicantId={applicantId} />
            <HeaderPortal>
                <PermissionControlledInput
                    rule="update:*"
                    collection="opening_applicants"
                >
                    <EditItemButton variant="ghost" />
                </PermissionControlledInput>
            </HeaderPortal>
        </div>
    );
}
